import { createApi } from '@reduxjs/toolkit/query/react';
import { baseUrl } from '../../../../../serverUrl';
import { baseQueryWithAuth } from '../../baseQueryWithAuth.ts';

export const unitSlice = createApi({
    reducerPath: 'UnitApi',
    baseQuery: baseQueryWithAuth,
    tagTypes: ['Unit'],
    endpoints: (builder) => ({
        // apartment unit details
        getUnitDetails: builder.query({
            query: ({ apartmentId, month, year }) => {
                let url = `/landlord/react-house-apartment-tenant/?apartment_id=${apartmentId}`;
                if (month) url += `&month=${month}`;
                if (year) url += `&year=${year}`;
                return url;
            },
            providesTags: ['Unit'],
        }),

        // get correct terminlogy for unit type
        getCorrectTerminology: builder.query({
            query: ({ apartmentId }) => 
                `/landlord/react-rent-scharge?property_id=${apartmentId}`,
            providesTags: ['Unit'],
        }),

        // save unit endpoint
        saveUnit: builder.mutation({
            query: (data) => ({
                url: '/landlord/house/',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Unit'],
        }),

        deleteUnit: builder.mutation({
            query: (houseId) => ({
                url: `/landlord/house/${houseId}/`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Unit'],
        }),

        getAllUnits: builder.query({
            query: ({ landlordId }) => 
                `/landlord/react-house-landlord-tenant/?landlord_id=${landlordId}`,
            providesTags: ['Unit'],
        }),
    }),
});

// Export hooks for usage in components
export const { useGetUnitDetailsQuery, useGetCorrectTerminologyQuery, useSaveUnitMutation, useDeleteUnitMutation, useGetAllUnitsQuery} = unitSlice;
